import { useParams } from "react-router-dom";
import * as React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Box,
  CircularProgress,
  Button,
  TextField,
  MenuItem,
} from "@mui/material";

const EditAdminUserForm = ({
  setExpanded,
  setAdminUserUpdated,
  setAdminUserError,
  setOpen,
  setMessage,
  setAlertColour,
}) => {
  const { adminUser } = useParams();
  const [adminUserData, setAdminUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [submit, setSubmit] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const respUser = await axios.get(`/adminUserRec/${adminUser}`);

      setAdminUserData(respUser.data.adminUser);
    };

    fetchData().then(() => setIsLoading(false));
  }, [submit]);

  const initialValues = {
    email: adminUserData.email,
    inputEndDate: adminUserData.inputEndDate,
    firstName: adminUserData.firstName,
    lastName: adminUserData.lastName,
    inputIPAddress: adminUserData.ipAddress,
    mfaKey: adminUserData.mfaKey,
    inputState: adminUserData.state,
    username: adminUserData.username,
  };

  const adminUserSchema = yup.object().shape({
    firstName: yup
      .string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    lastName: yup
      .string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    email: yup.string().email("Invalid email").required("Required"),
    username: yup
      .string()
      .min(5, "Too Short!")
      .max(10, "Too Long!")
      .required("Required"),
    inputIPAddress: yup.string().min(9, "Too Short!").max(35, "Too Long!"),
  });

  const handleFormSubmit = (values) => {
    axios
      .patch(`/patchAdminUserRec`, { values: values })
      .then((res) => {
        setAdminUserUpdated(true);

        setSubmit(!submit);
        setMessage(res.data);
        setAlertColour("success");
        setExpanded(false);
      })
      .then(() => {
        setOpen(true);
      })
      .catch((err) => {
        setAlertColour("error");
        setMessage(err.response.data);

        setSubmit(!submit);

        setOpen(true);
      });
  };

  if (isLoading)
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  else
    return (
      <Box p="20px" sx={{ backgroundColor: "#212121", mt: "5px", mb: "5px" }}>
        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={adminUserSchema}
        >
          {({
            values,
            errors,
            touched,
            resetForm,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
            dirty,
          }) => (
            <form onSubmit={handleSubmit} onReset={resetForm}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="First Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.firstName}
                  name="firstName"
                  error={!!touched.firstName && !!errors.firstName}
                  helperText={touched.firstName && errors.firstName}
                  sx={{ gridColumn: "span 1" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Last Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.lastName}
                  name="lastName"
                  error={!!touched.lastName && !!errors.lastName}
                  helperText={touched.lastName && errors.lastName}
                  sx={{ gridColumn: "span 1" }}
                />

                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="username"
                  disabled={true}
                  value={values.username}
                  name="username"
                  sx={{ gridColumn: "span 1" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.email}
                  name="email"
                  error={!!touched.email && !!errors.email}
                  helperText={touched.email && errors.email}
                  sx={{ gridColumn: "span 2" }}
                />

                <TextField
                  select
                  value={values.inputState}
                  name="inputState"
                  label="inputState"
                  onChange={handleChange}
                >
                  <MenuItem value={"Inactive"}>Inactive</MenuItem>
                  <MenuItem value={"Active"}>Active</MenuItem>
                </TextField>

                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="IP Address"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.inputIPAddress}
                  name="inputIPAddress"
                  error={!!touched.inputIPAddress && !!errors.inputIPAddress}
                  helperText={touched.inputIPAddress && errors.inputIPAddress}
                  sx={{ gridColumn: "span 1" }}
                />
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  disabled={!dirty}
                  type="submit"
                  color="secondary"
                  variant="contained"
                  sx={{ ml: "2px", mr: "2px" }}
                >
                  Save Edits
                </Button>
                <Button type="reset" variant="contained" color="secondary">
                  Reset
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    );
};

export default EditAdminUserForm;
